import { render, staticRenderFns } from "./MoviesFilter.vue?vue&type=template&id=d5d170e8&"
import script from "./MoviesFilter.vue?vue&type=script&lang=js&"
export * from "./MoviesFilter.vue?vue&type=script&lang=js&"
import style0 from "./MoviesFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports